/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetPlanInfoListResponse
 */
export interface ResponseGetPlanInfoListResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoListResponse
     */
    baseId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoListResponse
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoListResponse
     */
    gorupNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoListResponse
     */
    multiCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoListResponse
     */
    planId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoListResponse
     */
    planName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoListResponse
     */
    productCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoListResponse
     */
    shipmentConfirmationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoListResponse
     */
    shippedDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoListResponse
     */
    singleCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoListResponse
     */
    skuCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetPlanInfoListResponse
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetPlanInfoListResponse
     */
    userName?: string;
}

/**
 * Check if a given object implements the ResponseGetPlanInfoListResponse interface.
 */
export function instanceOfResponseGetPlanInfoListResponse(value: object): value is ResponseGetPlanInfoListResponse {
    return true;
}

export function ResponseGetPlanInfoListResponseFromJSON(json: any): ResponseGetPlanInfoListResponse {
    return ResponseGetPlanInfoListResponseFromJSONTyped(json, false);
}

export function ResponseGetPlanInfoListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetPlanInfoListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'gorupNum': json['gorup_num'] == null ? undefined : json['gorup_num'],
        'multiCount': json['multi_count'] == null ? undefined : json['multi_count'],
        'planId': json['plan_id'] == null ? undefined : json['plan_id'],
        'planName': json['plan_name'] == null ? undefined : json['plan_name'],
        'productCount': json['product_count'] == null ? undefined : json['product_count'],
        'shipmentConfirmationId': json['shipment_confirmation_id'] == null ? undefined : json['shipment_confirmation_id'],
        'shippedDate': json['shipped_date'] == null ? undefined : json['shipped_date'],
        'singleCount': json['single_count'] == null ? undefined : json['single_count'],
        'skuCount': json['sku_count'] == null ? undefined : json['sku_count'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'userName': json['user_name'] == null ? undefined : json['user_name'],
    };
}

export function ResponseGetPlanInfoListResponseToJSON(json: any): ResponseGetPlanInfoListResponse {
    return ResponseGetPlanInfoListResponseToJSONTyped(json, false);
}

export function ResponseGetPlanInfoListResponseToJSONTyped(value?: ResponseGetPlanInfoListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'created_at': value['createdAt'],
        'gorup_num': value['gorupNum'],
        'multi_count': value['multiCount'],
        'plan_id': value['planId'],
        'plan_name': value['planName'],
        'product_count': value['productCount'],
        'shipment_confirmation_id': value['shipmentConfirmationId'],
        'shipped_date': value['shippedDate'],
        'single_count': value['singleCount'],
        'sku_count': value['skuCount'],
        'user_id': value['userId'],
        'user_name': value['userName'],
    };
}

